import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { visitorService } from '../../../shared/services/visitors/visitorService';
import { Formik, Form } from 'formik';
import { Box, Button, Paper, Typography, Alert } from '@mui/material';
import { FormContent } from '../components/VisitorForm/FormContent';
import { useToast } from '../../../shared/hooks/useToast';

export default function VisitorFormPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
   const { showToast } = useToast();

  const { data: participant, isLoading } = useQuery({
    queryKey: ['participant', id],
    queryFn: () => visitorService.getById(id!),
    enabled: !!id,
  });

  const mutation = useMutation({
    mutationFn: (data: any) => visitorService.update(id!, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['participant', id] });
      showToast('Participante atualizado com sucesso!', 'success');
      navigate(`/visitors/${id}`);
    }
  });

  if (isLoading || !participant) return null;

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" fontWeight={600} gutterBottom>
        Editar Participante
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Formik
          initialValues={{
            name: participant.name,
            email: participant.email,
            cpf: participant.cpf,
            phone: participant.phone || '',
          }}
          onSubmit={mutation.mutate}
          enableReinitialize
        >
          {({ values, errors, touched, isSubmitting, setFieldValue }) => (
            <Form>
              <FormContent
                values={values}
                errors={errors}
                touched={touched}
                isSubmitting={isSubmitting}
                setFieldValue={setFieldValue}
              />
              <Box sx={{ display: 'flex', gap: 2, mt: 4 }}>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={isSubmitting}
                >
                  Salvar
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => navigate(`/visitors/${id}`)}
                  disabled={isSubmitting}
                >
                  Cancelar
                </Button>
              </Box>
              {mutation.isError && (
                <Alert severity="error" sx={{ mt: 2 }}>
                  Erro ao atualizar participante
                </Alert>
              )}
            </Form>
          )}
        </Formik>
      </Paper>
    </Box>
  );
}